import { pickElement as $ } from "../../utils/pickelements";

import { NewsArea } from "./newsarea/newsarea";

(async () => {
    try {
        const newsArea = new NewsArea($("#news"));

        await newsArea.init();
    } catch (e) {
        console.error(e);
        alert((Error.isError(e)) ? e.message : e);
    }
})();
